import * as React from 'react';

interface RequiredInputHelperProps {
  isFilled?: boolean;
}

export const RequiredInputHelper: React.FC<RequiredInputHelperProps> = ({ isFilled }) => {
  if (isFilled) {
    return null;
  }

  return (
    <span className="text-danger" style={{ fontSize: '12px', marginLeft: '4px' }}>
      * Required
    </span>
  );
};
